module.exports = __webpack_public_path__ + "img/logo-text.dfb5b474.webp";